import recommendationsTypes from "./recommendationsTypes";
import {
  fetchPeopleRecommendationsApi,
  sendRecommendationFeedbackApi,
} from "../../services/recommendationsService";

const getToken = (state) => state.user?.token;

export const fetchPeopleRecommendations =
  ({ limit = 20, cursor = null } = {}) =>
  async (dispatch, getState) => {
    const token = getToken(getState());
    if (!token) {
      return;
    }

    dispatch({ type: recommendationsTypes.FETCH_START, payload: { append: Boolean(cursor) } });
    try {
      const response = await fetchPeopleRecommendationsApi(token, { limit, cursor });
      dispatch({
        type: recommendationsTypes.FETCH_SUCCESS,
        payload: {
          items: response.results || [],
          cursor: response.cursor,
          append: Boolean(cursor),
        },
      });
    } catch (err) {
      dispatch({
        type: recommendationsTypes.FETCH_FAILURE,
        payload: err.message || "Unable to load recommendations.",
      });
    }
  };

export const dismissRecommendation =
  (recId, targetUserId) => async (dispatch, getState) => {
    dispatch({ type: recommendationsTypes.DISMISS, payload: recId });
    const token = getToken(getState());
    if (!token) {
      return;
    }
    try {
      await sendRecommendationFeedbackApi(token, {
        recId,
        targetUserId,
        action: "dismissed",
      });
    } catch (err) {
      // best-effort telemetry; no user-facing error
    }
  };

export const markRecommendationViewed =
  (recId, targetUserId) => async (dispatch, getState) => {
    const state = getState().recommendations;
    if (state.viewedLookup[recId]) {
      return;
    }

    dispatch({ type: recommendationsTypes.MARK_VIEWED, payload: recId });

    const token = getToken(getState());
    if (!token) {
      return;
    }

    try {
      await sendRecommendationFeedbackApi(token, {
        recId,
        targetUserId,
        action: "viewed",
      });
    } catch (err) {
      // noop
    }
  };

export const sendFollowFeedback =
  (recId, targetUserId) => async (dispatch, getState) => {
    const token = getToken(getState());
    if (!token) {
      return;
    }
    try {
      await sendRecommendationFeedbackApi(token, {
        recId,
        targetUserId,
        action: "followed",
      });
    } catch (err) {
      // noop
    }
  };
